<template>
  <material-card v-if="$store.state.menu.Distributions" class="card-tabs" color="#004D40">
    <v-flex slot="header">
      <v-tabs v-model="tabs" color="transparent" slider-color="white">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-cart-outline</v-icon>Заказы
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-account-supervisor</v-icon>Аккаунты
        </v-tab>
        <v-tab>
          <v-icon class="mr-2">mdi-format-list-bulleted-type</v-icon>Группы
        </v-tab>
      </v-tabs>
    </v-flex>
    <v-tabs-items>
      <v-tab-item>
        <div class="tab-products">
          <List v-if="tabs===1" />
          <Orders v-else-if="tabs===0" />
          <Groups v-else-if="tabs===2" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </material-card>
</template>
<script>
import List from "../components/core/Distributors/List";
import Orders from "../components/core/Distributors/Orders";
import Groups from "../components/core/Distributors/Groups";
export default {
  components: {
    List,
    Orders,
    Groups
  },
  data() {
    return {
      tabs: null
    };
  },
  methods: {},
  mounted() {
    // console.log("dss" + this.$route.query.tab);
    // if (this.$route.query.tab > 0) {
    //   setTimeout(()=> {
    //       this.tabs = this.$route.query.tab;
    //   },100)
    // } else {
    //   this.tabs = 0;
    // }

    this.tabs = 0;
  },
  watch: {
    // $route(val) {
    //   if (val === 0 || val > 0) {
    //     this.tabs = val.query.tab;
    //   }
    // }
    // tabs(val){
    //   if (val===0 || val>0){
    //       this.$router.push({path:'distributions', query:{tab:val}})
    //   }
    // }
  }
};
</script>

<style>
.tab-products {
  min-height: 70vh;
}
</style>

